export const MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
} as const

export const MESSAGE_STATUSES = {
  LOADING: 'loading',
  ERROR: 'error',
} as const

export const USER_MESSAGE_MAX_CHARS = 1000
